import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';

export default function AppShell() {
  return (
    <div
      className="gt-themed"
      style={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        background: 'var(--gt-surface-1)',
      }}
    >
      <AppSidebar />
      <main
        style={{
          flex: 1,
          minWidth: 0,
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
